import BootstrapVue from 'bootstrap-vue';

import Vue from 'vue';

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vuetify from 'vuetify'

import App from './App.vue';

import '@/router/componentHooks' // IMPORTANT: Must happen before router is loaded
import router from '@/router/router';

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// import store from './store'

import store from './store/store'

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.use(BootstrapVue);
Vue.use(Vuetify)

// import './scss/variables.scss'
// import './scss/global.scss'
import './scss/app.scss'

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

Vue.config.productionTip = false;

// See https://sentry.io/onboarding/open-streamflow/get-started/
Sentry.init({
  Vue,
  dsn: "https://75971880c720434e86916ab354c14c9b@o1053436.ingest.sentry.io/6037933",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "openstreamflow.com", /^\//],

    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Keep errors in Vue renderer flowing to dev console
  logErrors: true
});

// Initialize recent sites from local storage

console.log('running main.ts')

store.dispatch('initRecentSearches');
store.dispatch('initRecentSites');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
